/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Usergroup1Inputs */

const en_entity_usergroup1 = /** @type {(inputs: Entity_Usergroup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Group`)
};

const de_entity_usergroup1 = /** @type {(inputs: Entity_Usergroup1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzergruppe`)
};

/**
* | output |
* | --- |
* | "User Group" |
*
* @param {Entity_Usergroup1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_usergroup1 = /** @type {((inputs?: Entity_Usergroup1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Usergroup1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_usergroup1(inputs)
	return de_entity_usergroup1(inputs)
});
export { entity_usergroup1 as "entity_userGroup" }